// extracted by mini-css-extract-plugin
export var btn = "rounded-button-module--btn--43f0b";
export var button = "rounded-button-module--button--f3b6e";
export var extraSmallButton = "rounded-button-module--extraSmallButton--b61bd";
export var largeButton = "rounded-button-module--largeButton--b2b94";
export var mediumButton = "rounded-button-module--mediumButton--a9e75";
export var secondaryButton = "rounded-button-module--secondaryButton--f23fa";
export var smallButton = "rounded-button-module--smallButton--00ada";
export var tertiaryButton = "rounded-button-module--tertiaryButton--cd220";